/**
 * ChatActionType
 *
 * The closed set of rows shown in the chat-actions bottom sheet, in render
 * order. Promoted to a domain `enum` per `conventions.md` § "Enums live in the
 * domain layer". Drives both the row order and the per-row tap switch.
 *
 * Flutter source of truth: `lib/domain/enums/chat_action_type.dart:1-5` —
 * `enum ChatActionType { blockConversation, blockUser, mute }`. The ordinal
 * order there is the render order in `getChatActions()`
 * (`lib/domain/entity/bottom_sheet/chat_actions_bottom_sheet.dart:152-179`):
 * block conversation → block user → mute. This enum preserves that order.
 */

export enum ChatActionType {
  blockConversation = 'blockConversation',
  blockUser = 'blockUser',
  mute = 'mute',
}
